"use client"

import Link from "next/link"
import { siteConfig } from "@/config"
import {
  Fa6Icons,
  FiGithub,
  MdArrowOutward,
  MdOutlineAlternateEmail,
} from "@/constant"
import { handleClick } from "@/utils"

function Mail() {
  return (
    <MdOutlineAlternateEmail
      size={18}
      className="text-muted-foreground cursor-pointer duration-300 sm:hover:text-black dark:sm:hover:text-white"
      onClick={() =>
        handleClick(`mailto:${siteConfig.socialHandle.mail}`, true)
      }
    />
  )
}

function GitHub() {
  return (
    <FiGithub
      size={18}
      className="text-muted-foreground cursor-pointer duration-300 sm:hover:text-black dark:sm:hover:text-white"
      onClick={() => handleClick(`${siteConfig.socialHandle.github}`)}
    />
  )
}

function LinkedIn() {
  return (
    <Fa6Icons.FaLinkedin
      size={18}
      className="text-muted-foreground cursor-pointer duration-300 sm:hover:text-black dark:sm:hover:text-white"
      onClick={() => handleClick(`${siteConfig.socialHandle.linkedIn}`)}
    />
  )
}

function HireMe() {
  return (
    <div className="flex items-center gap-5">
      <Link
        href="/hire-me"
        className="text-muted-foreground flex cursor-pointer items-center gap-1 text-sm duration-300 sm:hover:text-black md:text-base dark:sm:hover:text-white"
      >
        <MdArrowOutward size={20} /> hire me
      </Link>
    </div>
  )
}

interface Props {
  mail?: boolean
  github?: boolean
  linkedin?: boolean
  hireMe?: boolean
}

export function SocialHandle({ mail, github, linkedin, hireMe }: Props) {
  return (
    <>
      {mail && <Mail />}
      {github && <GitHub />}
      {linkedin && <LinkedIn />}
      {hireMe && <HireMe />}
    </>
  )
}

export const socialContact = [
  {
    name: "GitHub",
    url: siteConfig.socialHandle.github,
    icon: <FiGithub size={18} />,
  },
  {
    name: "LinkedIn",
    url: siteConfig.socialHandle.linkedIn,
    icon: <Fa6Icons.FaLinkedin size={18} />,
  },
]
